import React from 'react';
import { Card, ListGroup, ListGroupItem } from 'react-bootstrap';
import { FaHome, FaGlobe, FaCloud, FaFile, FaFolderOpen } from 'react-icons/fa';

/**UI Component for the different state nodes
 * handles an onClick for opening up the message
 * also has  logo and colour handler
 */
export default class StateNode extends React.Component {
    componentWillMount() {
        console.log(this.props.state);
        this.setState({
            colour: this.setColour(this.props.state),
            isOpen: false
        });
    }
    /**Handles the colour of the node */
    setColour = () => {
        const { state } = this.props;
        let colour = "info";
        if (state === "completed") {
            colour = "success";
        } else if (state === "failed") {
            colour = "danger";
        }
        return colour;
    };
    /**Icon for the type of node */
    iconChooser = () => {
        switch (this.props.nodeType) {
            case 'root':
                return (<FaHome />);
            case 'hub':
                return (<FaGlobe />);
            case 'site':
                return (<FaCloud />);
            case 'doc':
                return (<FaFolderOpen />);
            case 'page':
                return (<FaFile />);
            default:
                return '';
        }
    };
    /**Maps the messages into a list item */
    messageMapper = () => {
        // if (this.props.stateType === "state") {
        return this.props.messages.map((m, index) => {
            return <ListGroupItem as="li" key={"msg" + index} variant={this.setColour()}>{m}</ListGroupItem>;
        });
        // } else {
        //     return this.props.messages.join("\n");
        // }

    };
    onClickOpen = () => this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    render() {
        const { colour, isOpen } = this.state;
        return <Card bg={colour} text="white" style={{ marginTop: "10px" }} onClick={this.onClickOpen}>
            <Card.Header>{this.props.name} {this.iconChooser()}</Card.Header>
            {isOpen ?
                <ListGroup variant={this.setColour()} as="ul">
                    {this.props.state === "completed" &&
                        this.props.stateType === "state" ?
                        <ListGroupItem as="li" key={"msg"} variant={this.setColour()}> Node sucessfully completed</ListGroupItem>

                        : this.messageMapper()}
                </ListGroup>
                : undefined
            }
        </Card >;
    }
}



// WEBPACK FOOTER //
// ./src/components/publishedResults/stateNode.js